const SectionHeader = ({ title, right }) => (
    <div className="flex items-center rounded-t-xl justify-between px-5 py-4 border-b border-border-primary bg-background-tertiary/40 backdrop-blur-sm">
        <div className="flex flex-col">
            <p className="text-[13px] font-semibold tracking-wide text-text-primary m-0">{title}</p>
        </div>

        {right}
    </div>
);

export default SectionHeader;